import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Typography } from '@tempmee/react';
import { fetchMultidayJobs } from '../../actions/multidayActions';
import { createLoadingSelector } from '../../apis/selectors';
import history from '../../history';
import { ListPageHeader } from '../commonComponents/ListPageHeader';
import { Table } from '../commonComponents/Table/Table';
import { multidayColumn, multidayJobConditionalRowStyles } from '../commonComponents/jobs-column';

const ROWS_PER_PAGE = 15;

const actions = ['FETCH_MULTIDAY_JOBS'];
const loadingSelector = createLoadingSelector(actions);

export const MultidayList = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => loadingSelector(state));
  const allJobs = useSelector((state) => state.multiday.allJobs);
  const searchParams = useSelector((state) => state.multiday.searchParams);
  const totalJobs = useSelector((state) => state.multiday.totalJobs);
  const totalJobsPostedByMDB = useSelector((state) => state.multiday.totalJobsPostedByMDB);
  const totalPages = Math.ceil(totalJobs / ROWS_PER_PAGE);

  const handleTableChange = (page) => {
    dispatch(fetchMultidayJobs({ page }));
  };

  const getJobUrl = (job) => `/multiday/${job.id}`;

  const getOfficeUrl = (userId, userType) => `/user/${userType.toLowerCase()}/${userId}`;

  const getColumn = () =>
    multidayColumn({
      getJobUrl,
      getOfficeUrl,
    });

  useEffect(() => {
    dispatch(fetchMultidayJobs({ page: searchParams.page ? searchParams.page : 1 }));
  }, [dispatch]);

  return (
    <div
      style={{
        display: 'flex',
        height: '100%',
        overflowY: 'auto',
        flexDirection: 'column',
        position: 'relative',
        alignItems: 'center',
      }}
    >
      <div style={{ width: '90%' }}>
        <ListPageHeader
          title="Multi-Day Booking"
          isLoading={isLoading}
          actions={(
            <Button onClick={() => history.push('/multiday/post')}>Post Multi-Day</Button>
          )}
          meta={(
            <>
              <Typography size="body_large" bold>
                Total | {new Intl.NumberFormat().format(totalJobs)}
              </Typography>
              <Typography size="body_large" bold>
                Total Jobs | {new Intl.NumberFormat().format(totalJobsPostedByMDB)}
              </Typography>
            </>
          )}
        />
      </div>
      <div style={{ width: '90%', paddingTop: 20 }}>
        <Table
          keyField="multiday.id"
          columns={getColumn()}
          data={allJobs}
          noDataComponent="There are no Jobs"
          isLoading={isLoading}
          totalPages={totalPages}
          showTotal={false}
          paginationPerPage={ROWS_PER_PAGE}
          paginationTotalRows={totalJobs}
          onPageChange={handleTableChange}
          showColumnsToHide={false}
          sortServer={false}
          conditionalRowStyles={multidayJobConditionalRowStyles}
        />
      </div>
    </div>
  );
};
